export const regions = {
  All: ['All'],
  India: ['Ahmedabad', 'Pune', 'Vadodara', 'Rajkot'],
  'The Netherlands': ['Amsterdam', 'Rotterdam', 'The Hague'],
  Canada: ['Toronto', 'Vancouver', 'Montreal'],
  USA: ['New York', 'Los Angeles', 'Chicago'],
  'South Africa': ['Johannesburg', 'Cape Town', 'Durban'],
  UAE: ['Dubai', 'Abu Dhabi', 'Sharjah'],
  UK: ['London', 'Manchester', 'Birmingham'],
  Belgium: ['Brussels', 'Antwerp', 'Ghent'],
  Denmark: ['Copenhagen', 'Aarhus', 'Odense'],
  Finland: ['Helsinki', 'Tampere', 'Turku'],
  France: ['Paris', 'Lyon', 'Marseille'],
  Germany: ['Berlin', 'Munich', 'Frankfurt'],
  Iceland: ['Reykjavik', 'Akureyri', 'Hafnarfjordur'],
  Norway: ['Oslo', 'Bergen', 'Stavanger'],
  Sweden: ['Stockholm', 'Gothenburg', 'Malmo'],
};

export const countries = Object.keys(regions);
